function rank(s){
 const source=String(s?.source||'');
 if(s?.reviewSource||/yönetici onayı/i.test(source))return -1;
 if(s?.tdkVerified)return 0;
 if(/TDK (12|11|2007)\. baskı|TDK Güncel Türkçe/i.test(source))return (s.archivedEdition==='11'||/TDK 11\. baskı/i.test(source))?2:(s.archivedEdition==='2007'||/TDK 2007\. baskı/i.test(source))?3:1;
 if(/Dil Derneği/i.test(source))return 4;
 if(/Derleme|Tarama|Terimleri|Hasol|Türkiye Türkçesi Ağızları/i.test(source))return 5;
 if(/wiki|viki|kaikki/i.test(source)||s?.wikiWord)return 20;
 return 10;
}
function orderedSenses(senses=[]){return senses.map((s,i)=>({s,i})).sort((a,b)=>rank(a.s)-rank(b.s)||a.i-b.i).map(x=>x.s);}
function displaySenses(senses=[]){
 const ordered=orderedSenses(senses);if(!ordered.length)return [];
 const first=ordered[0],best=rank(first),seen=new Set();
 return ordered.filter(s=>rank(s)===best).filter(s=>{const key=s.text.trim().toLocaleLowerCase('tr-TR');if(seen.has(key))return false;seen.add(key);return true;});
}
function sourceLabel(s){const source=String(s?.source||'');if(s?.tdkVerified)return 'TDK';if(/TDK.*baskı/i.test(source))return 'TDK · arşiv';if(/Dil Derneği/i.test(source))return 'Dil Derneği';if(/wiki|viki|kaikki/i.test(source)||s?.wikiWord)return 'Vikisözlük';if(/yönetici onayı/i.test(source))return 'Kelimo';return source.split(' / ')[0];}
module.exports={rank,orderedSenses,displaySenses,sourceLabel};
